export enum GTMApiStatus {
  Started = 'Started',
  Success = 'Success',
  Failed = 'Failed',
}

export enum GTMEvents {
  PageView = 'page_view',
  Click = 'click',
  AccordionExpand = 'accordion_expand',
  ChatOpen = 'chat_open',
  PageLoad = 'page_load',
  DeviceInventoryView = 'device_inventory_view',
  DeviceInventoryAddView = 'device_inventory_add_view',
  DeviceInventoryAddFail = 'device_inventory_add_fail',
  DeviceInventoryAddComplete = 'device_inventory_add_complete',
  ClickInteraction = 'click_interaction',
  MakePayment = 'make_payment',
  UpdatePayment = 'update_payment',
  AddFamily = 'add_family',
  Onboarding = 'onboarding',
  AvatarSkip = 'avatar_skip',
  ContractChange = 'contract_change',
  Error = 'error',
  Login = 'login',
  ResetPassword = 'reset_password',
  RedeemCoupon = 'redeem_coupon',
  LiveChat = 'live_chat',
  InvitePhoneNumber = 'invite_phone_number',
}

export enum GTMDeviceFlow {
  AddDevice = 'Add device',
  EditDevice = 'Edit device',
  DeleteDevice = 'Delete device',
}

export enum GTMClaimType {
  FileAClaim = 'File a claim',
  CancelMyPlan = 'Cancel my plan',
  TechSupport = 'Tech support links',
}

export enum GTMOnboardingEvents {
  Start = 'onboarding_form_start',
  InProcess = 'onboarding_form_step_view',
  Complete = 'onboarding_form_step_complete',
  Failed = 'onboarding_form_fail',
}

export enum GTMLoginEvents {
  Login = 'login',
  LoginSuccess = 'login_success',
  LoginError = 'login_error',
}

export enum OnboardingSteps {
  CreateLogin = 'Create Login',
  Start = 'Start Onboarding',
  VerifyAccount = 'Verify Account',
  CreateOTP = 'Create OTP',
  VerifyOTP = 'Verify OTP',
  ResendOTP = 'Resend OTP',
  ReviewContact = 'Review Contact',
  VerifyNewEmail = 'Verify New Email',
  CreateOTPForEditedEmail = 'Create OTP For Edited Email',
  EditPhone = 'Edit Phone',
  CreateOTPForEditedPhone = 'Create OTP For Edited Phone',
  ReviewAddress = 'Review Address',
  EditAddress = 'Edit Address',
  SaveAddress = 'Save Address',
  CreatePassword = 'Create Password',
  Success = 'Success',
}
